// extracted by mini-css-extract-plugin
export default {"content":"TabItem--content--931a02","active":"TabItem--active--8a9c57","disabled":"TabItem--disabled--5a17a8","error":"TabItem--error--fec936"};